import { render, staticRenderFns } from "./kindChooseViewsixthtk.vue?vue&type=template&id=321f302b&scoped=true"
import script from "./kindChooseViewsixthtk.vue?vue&type=script&lang=js"
export * from "./kindChooseViewsixthtk.vue?vue&type=script&lang=js"
import style0 from "./kindChooseViewsixthtk.vue?vue&type=style&index=0&id=321f302b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321f302b",
  null
  
)

export default component.exports